import { FormControl, Pagination } from 'react-bootstrap';

import classNames from 'classnames';

export const BootstrapPagination = ({ tableInstance }) => {
  const {
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = tableInstance;

  return (
    <Pagination className="justify-content-end">
      <Pagination.First
        disabled={!canPreviousPage}
        onClick={() => gotoPage(0)}
      />
      <Pagination.Prev
        onClick={() => previousPage()}
        disabled={!canPreviousPage}
      />
      <FormControl
        type="number"
        value={pageIndex + 1}
        onChange={(e) => {
          const page = e.target.value ? Number(e.target.value) - 1 : 0;
          gotoPage(page);
        }}
        style={{ width: '75px' }}
      />
      <Pagination.Next onClick={() => nextPage()} disabled={!canNextPage} />
      <Pagination.Last
        onClick={() => gotoPage(pageCount - 1)}
        disabled={!canNextPage}
      />
    </Pagination>
  );
};

export const BootstrapItemsPerPage = ({ tableInstance, itemsPerPage }) => {
  const {
    setPageSize,
    state: { pageSize },
  } = tableInstance;
  return (
    <Pagination size="sm" className={classNames('justify-content-end')}>
      <span className="me-2 normalFontSize">Items per page</span>
      {itemsPerPage.map((item) => (
        <Pagination.Item
          key={item}
          onClick={(e) => {
            setPageSize(Number(e.target.getAttribute('value')));
          }}
          value={item}
          active={item === pageSize}
        >
          {item}
        </Pagination.Item>
      ))}
    </Pagination>
  );
};
